import { blue } from '@/lib/colours';

import { FilterIcon } from '@/components/icons';
import { Box, Typography } from '@/primitives';
import { dropdownFilterMessages } from './messages';

export interface DropdownFilterProps {}

export function DropdownFilter({}: DropdownFilterProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        border: `1px solid ${blue[600]}`,
        borderRadius: '999px',
        color: blue[600],
        padding: '10px 11px',
      }}
    >
      <FilterIcon />
      <Typography variant="labellarge">
        {dropdownFilterMessages['dropdownFilter.label']}
      </Typography>
    </Box>
  );
}
